export default function (Component) {
  Component.__i18n = Component.__i18n || []
  Component.__i18n.push({
    "locale": "",
    "resource": {
      "ar-AE": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات المطور"])}
        }
      },
      "ar-EG": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات المطور"])}
        }
      },
      "ar-SA": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["إعدادات المطور"])}
        }
      },
      "de-DE": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entwicklereinstellungen"])}
        }
      },
      "de-AT": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entwicklereinstellungen"])}
        }
      },
      "de-CH": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Entwicklereinstellungen"])}
        }
      },
      "en-US": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Developer Settings"])}
        }
      },
      "en-GB": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Developer Settings"])}
        }
      },
      "it-IT": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Impostazioni sviluppatore"])}
        }
      },
      "fr-FR": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres du développeur"])}
        }
      },
      "es-ES": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configuración de desarrollador"])}
        }
      },
      "pl-PL": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ustawienia programisty"])}
        }
      },
      "nl-NL": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ontwikkelaarsinstellingen"])}
        }
      },
      "bg-BG": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки за програмисти"])}
        }
      },
      "bs-BA": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavke programera"])}
        }
      },
      "da-DK": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Udviklerindstillinger"])}
        }
      },
      "et-EE": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Arendaja seaded"])}
        }
      },
      "fi-FI": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kehittäjän asetukset"])}
        }
      },
      "el-GR": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις προγραμματιστή"])}
        }
      },
      "he-IL": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["הגדרות מפתח"])}
        }
      },
      "ga-IE": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Socruithe Forbróra"])}
        }
      },
      "ja-JP": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["開発者設定"])}
        }
      },
      "hr-HR": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Postavke programera"])}
        }
      },
      "lv-LV": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Izstrādātāja iestatījumi"])}
        }
      },
      "lt-LT": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Kūrėjo nustatymai"])}
        }
      },
      "pt-PT": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Configurações do desenvolvedor"])}
        }
      },
      "ro-RO": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Setări pentru dezvoltatori"])}
        }
      },
      "ru-RU": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Настройки разработчика"])}
        }
      },
      "sv-SE": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Utvecklarinställningar"])}
        }
      },
      "sk-SK": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavenia pre vývojárov"])}
        }
      },
      "cs-CZ": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavení vývojáře"])}
        }
      },
      "tr-TR": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geliştirici Ayarları"])}
        }
      },
      "hu-HU": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Fejlesztői beállítások"])}
        }
      },
      "fr-BE": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres du développeur"])}
        }
      },
      "fr-LU": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Paramètres du développeur"])}
        }
      },
      "mt-MT": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Settings tal-Iżviluppatur"])}
        }
      },
      "sl-SI": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nastavitve za razvijalce"])}
        }
      },
      "el-CY": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Ρυθμίσεις προγραμματιστή"])}
        }
      },
      "tr-CY": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Geliştirici Ayarları"])}
        }
      },
      "uk-UA": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Налаштування Розробника"])}
        }
      },
      "zh-CN": {
        "developerSettings": {
          "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["开发人员设定"])}
        }
      }
    }
  })
}
